<template>
	<nav class="navbar is-fixed-top" role="navigation" aria-label="main navigation">
		<div class="container is-fullhd">
			<div class="navbar-brand">
				<router-link
					v-if="hasActiveLeague"
					class="navbar-item has-text-primary"
					:to="{ name: 'league-home', params: { leagueKey: activeLeague.key } }"
					>ffstats.io</router-link
				>
				<router-link v-else class="navbar-item has-text-primary" :to="{ path: '/' }">ffstats.io</router-link>

				<a
					role="button"
					class="navbar-burger burger"
					aria-label="menu"
					aria-expanded="false"
					data-target="mobile-navbar-menu"
					v-if="hasLeagues && hasActiveLeague && leagues.length > 1"
					v-on:click.stop.prevent="toggleMobileNav"
					:class="{ 'is-active': isMobileNavOpen }"
				>
					<span aria-hidden="true"></span>
					<span aria-hidden="true"></span>
					<span aria-hidden="true"></span>
				</a>
			</div>

			<div id="mobile-navbar-menu" class="navbar-menu" :class="{ 'is-active': isMobileNavOpen }">
				<!-- Desktop navigation -->
				<div class="navbar-start is-hidden-mobile" v-if="hasActiveLeague">
					<router-link class="navbar-item" :to="{ name: 'league-home', params: { leagueKey: activeLeague.key } }"
						>Dashboard</router-link
					>
					<!--<router-link class="navbar-item" :to="{ name: 'league-teams', params: { leagueKey: activeLeague.key } }">Teams</router-link>-->
					<router-link class="navbar-item" :to="{ name: 'league-playoffs', params: { leagueKey: activeLeague.key } }"
						>Playoffs</router-link
					>
					<router-link class="navbar-item" :to="{ name: 'league-draft-dashboard', params: { leagueKey: activeLeague.key } }"
						>Draft</router-link
					>
					<router-link class="navbar-item" :to="{ name: 'league-players', params: { leagueKey: activeLeague.key } }"
						>Players</router-link
					>
					<router-link class="navbar-item" :to="{ name: 'league-faqs', params: { leagueKey: activeLeague.key } }"
						>FAQs</router-link
					>
				</div>

				<!-- Mobile league switcher -->
				<div class="navbar-start is-hidden-tablet" v-if="hasLeagues && hasActiveLeague && leagues.length > 1">
					<template v-for="(season, index) in seasons">
						<hr class="navbar-divider" v-if="index > 0" />
						<p class="navbar-item navbar-item-heading" v-if="seasons.length > 1">{{ season.season }}</p>
						<template v-for="league in season.leagues">
							<router-link
								class="navbar-item"
								:to="{ name: 'league-home', params: { leagueKey: league.key } }"
								active-class="is-active-league"
								>{{ league.name }}</router-link
							>
						</template>
					</template>
				</div>

				<!-- Desktop show active league name -->
				<div class="navbar-end is-hidden-mobile" v-if="hasLeagues">
					<div class="navbar-item has-dropdown" v-if="hasActiveLeague" :class="{ 'is-active': isMobileNavOpen }">
						<a class="navbar-link" @click.stop="toggleMobileNav">{{ activeLeague.name }}</a>

						<div class="navbar-dropdown is-right">
							<template v-for="(season, index) in seasonsWithNotActiveLeagues">
								<hr class="navbar-divider" v-if="index > 0" />
								<p class="navbar-item navbar-item-heading" v-if="seasonsWithNotActiveLeagues.length > 1">
									{{ season.season }}
								</p>
								<template v-for="notActiveLeague in season.leagues">
									<router-link
										class="navbar-item"
										:to="{ name: 'league-home', params: { leagueKey: notActiveLeague.key } }"
										>{{ notActiveLeague.name }}</router-link
									>
								</template>
							</template>
						</div>
					</div>
				</div>
				<div class="navbar-end" v-else>
					<div class="navbar-item">Loading...</div>
				</div>
			</div>
		</div>
	</nav>
</template>

<script>
export default {
	computed: {
		isMobileNavOpen() {
			return this.$store.state.isMobileNavOpen
		},
		hasLeagues() {
			return this.$store.getters.leagues.length > 0
		},
		leagues() {
			return this.$store.getters.leagues
		},
		hasActiveLeague() {
			return !!this.$store.getters.activeLeague
		},
		activeLeague() {
			return this.$store.getters.activeLeague
		},
		seasons() {
			return this.$store.getters.seasons
		},
		seasonsWithNotActiveLeagues() {
			return this.$store.getters.seasons.reduce((seasons, season) => {
				const notActiveLeagues = season.leagues.filter((league) => league.key != this.$store.state.activeLeagueKey)

				if (notActiveLeagues.length > 0) {
					seasons.push({
						...season,
						leagues: notActiveLeagues,
					})
				}

				return seasons
			}, [])
		},
	},
	methods: {
		toggleMobileNav() {
			this.$store.dispatch("toggleMobileNav")
		},
		hideMobileNav() {
			this.$store.dispatch("hideMobileNav")
		},
	},
}
</script>
